import type {
  Comparator,
  ComparatorName,
} from "../deliveryChargeRuleCommons.js";

export const comparisonFor = (
  comparisonSymbol: Comparator | ComparatorName,
  a: number,
  b: number,
): boolean => {
  switch (comparisonSymbol) {
    case "<":
    case "lessThan":
      return a < b;
    case ">":
    case "greaterThan":
      return a > b;
    case ">=":
    case "greaterThanEqual":
      return a >= b;
    case "<=":
    case "lessThanEqual":
      return a <= b;
    case "==":
    case "equals":
      return a == b;
    case "===":
    case "strictEquals":
      return a === b;
  }
};
